import { type BigNumberish, ethers } from "ethers";

export default function formatEther(wei?: BigNumberish): number {
  return Number(ethers.formatEther(wei ?? 0));
}
